import { render, staticRenderFns } from "./addLecturers.modal.vue?vue&type=template&id=4c2e1824"
import script from "./addLecturers.modal.vue?vue&type=script&lang=js"
export * from "./addLecturers.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports